<template>
  <div :class="rowClass">
    <dt class="text-sm font-medium text-gray-500">
      {{ label }}
    </dt>
    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
      <slot/>
    </dd>
  </div>
</template>

<script>
export default {
  name: 'DescriptionRow',

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    odd: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data(){
    return {
      bgEven: 'bg-gray-50',
      bgOdd: 'bg-white',
    }
  },

  computed: {
    rowClass(){
      return ( (this.odd) ? this.bgOdd : this.bgEven ) + ' ' + 'px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6';
    },
  },
}
</script>

<style scoped>

</style>
